import { useState, useEffect } from 'react';
import axios from 'axios';
import { Globe2, ChevronDown, ChevronUp } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function CountryAnalytics() {
    const [rows, setRows] = useState([]);
    const [open, setOpen] = useState(true);

    useEffect(() => {
        axios.get(`${API}/admin/analytics/countries`, { withCredentials: true })
            .then((r) => setRows(r.data))
            .catch(() => {});
    }, []);

    if (rows.length === 0) return null;
    const maxSignups = Math.max(...rows.map((r) => r.signups), 1);

    return (
        <div className="card-surface p-5 mb-6" data-testid="country-analytics-card">
            <button className="w-full flex items-center justify-between" onClick={() => setOpen(!open)} data-testid="country-analytics-toggle">
                <span className="flex items-center gap-2 font-bold text-sm" style={{ color: 'var(--text-primary)' }}>
                    <Globe2 className="w-4 h-4" style={{ color: 'var(--primary-color)' }} />
                    Country Analytics — where your ads pay off
                </span>
                {open ? <ChevronUp className="w-4 h-4" style={{ color: 'var(--text-muted)' }} /> : <ChevronDown className="w-4 h-4" style={{ color: 'var(--text-muted)' }} />}
            </button>
            {open && (
                <div className="mt-4 overflow-x-auto">
                    <table className="w-full text-sm" data-testid="country-analytics-table">
                        <thead>
                            <tr className="text-left text-xs uppercase tracking-wider" style={{ color: 'var(--text-muted)' }}>
                                <th className="py-2 pr-4">Country</th>
                                <th className="py-2 pr-4">Signups</th>
                                <th className="py-2 pr-4">Clicked Broker</th>
                                <th className="py-2 pr-4">Pending</th>
                                <th className="py-2 pr-4">Approved</th>
                                <th className="py-2 pr-4">Rejected</th>
                                <th className="py-2">Conversion</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((r) => (
                                <tr key={r.country} className="border-t" style={{ borderColor: 'var(--border-subtle)' }} data-testid={`country-row-${r.country}`}>
                                    <td className="py-2.5 pr-4">
                                        <span className="px-1.5 py-0.5 rounded text-[11px] font-black" style={{ backgroundColor: 'var(--primary-muted)', color: 'var(--primary-color)', border: '1px solid var(--border-highlight)' }}>
                                            {r.country === '??' ? 'Unknown' : r.country}
                                        </span>
                                    </td>
                                    <td className="py-2.5 pr-4">
                                        <div className="flex items-center gap-2">
                                            <span className="font-bold" style={{ color: 'var(--text-primary)' }}>{r.signups}</span>
                                            <div className="h-1.5 rounded-full" style={{ width: `${Math.max(6, (r.signups / maxSignups) * 90)}px`, backgroundColor: 'var(--primary-color)' }} />
                                        </div>
                                    </td>
                                    <td className="py-2.5 pr-4" style={{ color: '#059669', fontWeight: 600 }}>{r.clicked}</td>
                                    <td className="py-2.5 pr-4" style={{ color: '#F59E0B' }}>{r.pending}</td>
                                    <td className="py-2.5 pr-4" style={{ color: '#10B981', fontWeight: 600 }}>{r.approved}</td>
                                    <td className="py-2.5 pr-4" style={{ color: '#EF4444' }}>{r.rejected}</td>
                                    <td className="py-2.5">
                                        <span className="px-2 py-0.5 rounded-full text-xs font-black" style={{ backgroundColor: r.conversion >= 30 ? 'rgba(16,185,129,0.12)' : 'rgba(138,143,163,0.12)', color: r.conversion >= 30 ? '#10B981' : 'var(--text-secondary)' }}>
                                            {r.conversion}%
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <p className="text-[11px] mt-3" style={{ color: 'var(--text-muted)' }}>
                        Country is auto-detected at signup — accounts created before this feature show as “Unknown”. Conversion = approved ÷ signups.
                    </p>
                </div>
            )}
        </div>
    );
}
